import ManageMyCards from '@src/pages/ticketRestaurant/manageMyCards/index';

const ManageGiftCards = () => {
  return <ManageMyCards isCompliments={true} />;
};

export default ManageGiftCards;
